<template>
  <div class="tikus">
    <div class="tikus-list" v-for="(item, index) in tikus"
      :key="index">
      <div class="tikus-item">
        <div class="left"><P>{{ item.title }}</P></div>
        <div class="right">
          <div class="item-title">{{ item.title }}</div>
          <div class="logo">
            <img :src="logoUrl | handleImageUrl('30', '30')">
            <p>来学宝典</p>
          </div>
          <button @click="goPage(item)">开始答题</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const StaticUrl = process.env.VUE_APP_CDN;
export default {
  props: {
    tikus: {
      type: Array,
      default: () => [],
    }
  },

  data() {
    return {
      logoUrl: StaticUrl + 'img-lxbd.png',
    }
  },

  methods: {
    goPage(item) {
      localStorage.setItem('exam', JSON.stringify({id: item.id, title: item.title}));
      window.location.href = '/tiku/index.html';
    }
  }
}
</script>
<style scoped>
  .tikus-list {
    margin-bottom: 28px;
  }

  .tikus-item {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    padding: 0 30px;
  }

  .logo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 150px;
    font-size: 24px;
    color: #333;
  }

  .logo img {
    width: 30px;
    height: 30px;
  }

  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 13px;
    width: 230px;
    height: 138px;
    padding: 10px;
    background-image: url(https://cdn.laixue.com/h5/bg-tiku.jpg);
    background-size: 100% 100%;
    font-size: 30px;
    color: #333;
    box-sizing: border-box;
    font-weight: bold;
  }

  .left p {
    /* issue #1972 */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    width: 430px;
    height: 138px;
  }
/* issue 2297 */
  button {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 144px;
    height: 48px;
    background: #3385ff;
    border-radius: 24px;
    border: none;
    font-size: 24px;
    outline: 0!important;
    color: #fff;
  }

  .item-title {
    height: 70px;
    line-height: 35px;
    font-size: 30px;
    color: #333;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
</style>
